// extracted by mini-css-extract-plugin
module.exports = {"listTitle":"EditRecommend_listTitle__vC4Yw","list":"EditRecommend_list__3fDP3","addButton":"EditRecommend_addButton__iLba0"};